import { render, staticRenderFns } from "./FormChangeMetaDataDataset.vue?vue&type=template&id=7b6e9741&scoped=true&lang=pug"
import script from "./FormChangeMetaDataDataset.vue?vue&type=script&lang=js"
export * from "./FormChangeMetaDataDataset.vue?vue&type=script&lang=js"
import style0 from "./FormChangeMetaDataDataset.vue?vue&type=style&index=0&id=7b6e9741&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b6e9741",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/jquispe/itcm-inca-platform-app/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7b6e9741')) {
      api.createRecord('7b6e9741', component.options)
    } else {
      api.reload('7b6e9741', component.options)
    }
    module.hot.accept("./FormChangeMetaDataDataset.vue?vue&type=template&id=7b6e9741&scoped=true&lang=pug", function () {
      api.rerender('7b6e9741', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/tasks/powerbi/components/FormChangeMetaDataDataset.vue"
export default component.exports